export * from './user';

// Login Types
export const EMAIL_LOGIN_TYPE = 1;
export const PHONE_LOGIN_TYPE = 2;
export const BOTH_LOGIN_TYPE = 3;

// Irrigation Types
export const IRRIGATION_TYPE_OPTIONS = [
  { label: 'Drip', value: 'drip' },
  { label: 'Flood', value: 'flood' },
  { label: 'Rainfed', value: 'rainfed' },
];

export const IRRIGATION_TYPE_LABELS = Object.fromEntries(
  IRRIGATION_TYPE_OPTIONS.map(({ value, label }) => [value, label]),
);

export const DRAIN_CONDITION_LABELS = {
  'well-drained-soil': 'Well drained soil',
  'no-water-log': 'No waterlogging',
  'med-high-soil': 'Moderate to high soil permeability',
  'sloped-land': 'Prefer sloped land for natural runoff',
  ridges: 'Raised beds or ridges in poorly drained areas',
};

// Utility Functions
export const getIrrigationLabel = (value) => {
  const option = IRRIGATION_TYPE_OPTIONS.find(
    (option) => option.value === value,
  );
  return option ? option.label : 'N/A';
};

export const getLoginTypeLabel = (value) => {
  switch (Number(value)) {
    case EMAIL_LOGIN_TYPE:
      return 'Email';
    case PHONE_LOGIN_TYPE:
      return 'Phone';
    case BOTH_LOGIN_TYPE:
      return 'Both';
    default:
      return 'Unknown';
  }
};

export const getTableRowStyle = (index) => {
  return index % 2 === 1 ? 'bg-[#BFCADE]' : 'bg-[#E5F6FF]';
};

export const farmChangeFieldLabels = {
  name: 'Farm Name',
  crop_id: 'Crop',
  crop_variety_id: 'Crop Variety',
  size: 'Size (In Acres)',
  age: 'Age of Farm',
  soil_type_id: 'Soil Type',
  irrigation_type: 'Irrigation Type',
  drain_condition_slug: 'Drainage Condition',
  latitude: 'Latitude',
  longitude: 'Longitude',
  primary_pruning: 'Back Pruning Date',
  secondary_pruning: 'Fruit Pruning (Pasting) Date',
  sowing_date: 'Sowing Date',
  bud_burst: 'Bud Burst Date',
  flower_init: 'Flower Initiation Date',
  full_bloom: 'Full Bloom Date',
  harvesting_date: 'Harvesting Date',
  land_type: 'Land Type',
  soil_ph: 'Soil pH',
  soil_nitrogen: 'Soil Nitrogen',
  soil_phosphorus: 'Soil Phosphorus',
  soil_potassium: 'Soil Potassium',
  soil_org_carbon: 'Soil Organic Carbon',
  village_id: 'Village',
  sub_district_id: 'Sub District',
  district_id: 'District',
  state_id: 'State',
};

export const farmDetailSections = [
  {
    title: 'Farm Overview',
    fields: [
      'farmer_name',
      'name',
      'status',
      'latitude',
      'longitude',
      'crop_name',
      'crop_variety_name',
    ],
  },
  {
    title: 'Location',
    fields: [
      'state_name',
      'district_name',
      'sub_district_name',
      'village_name',
    ],
  },
  {
    title: 'Farm Profile',
    fields: [
      'size',
      'age',
      'land_type',
      'soil_type',
      'irrigation_type',
      'drain_condition_slug',
    ],
  },
  {
    title: 'Crop Timeline',
    fields: [
      'primary_pruning',
      'secondary_pruning',
      'sowing_date',
      'bud_burst',
      'flower_init',
      'full_bloom',
      'harvesting_date',
      'dap',
    ],
  },
  {
    title: 'Soil Profile',
    fields: [
      'soil_ph',
      'soil_nitrogen',
      'soil_phosphorus',
      'soil_potassium',
      'soil_org_carbon',
    ],
  },
  {
    title: 'Audit',
    fields: ['created_at', 'updated_at'],
  },
];

export const farmDetailFieldLabels = {
  ...farmChangeFieldLabels,
  status: 'Status',
  farmer_name: 'Farmer Name',
  crop_name: 'Crop Name',
  crop_variety_name: 'Crop Variety Name',
  state_name: 'State',
  district_name: 'District',
  sub_district_name: 'Sub District',
  village_name: 'Village',
  boundary: 'Boundary',
  soil_type: 'Soil Type',
  created_at: 'Created At',
  updated_at: 'Updated At',
  dap: 'DAP',
};

export const farmStatusLabels = {
  approved: 'Active',
  pending: 'Pending',
  rejected: 'Inactive',
};

export const statusConfig = {
  pending: {
    bgColor: 'bg-amber-50',
    borderColor: 'border-amber-200',
    accentColor: 'text-amber-700',
    badgeBg: 'bg-amber-100',
    badgeText: 'text-amber-800',
  },
  approved: {
    bgColor: 'bg-green-50',
    borderColor: 'border-green-200',
    accentColor: 'text-green-700',
    badgeBg: 'bg-green-100',
    badgeText: 'text-green-800',
  },
  rejected: {
    bgColor: 'bg-red-50',
    borderColor: 'border-red-200',
    accentColor: 'text-red-700',
    badgeBg: 'bg-red-100',
    badgeText: 'text-red-800',
  },
};

export const PAGE_CLASSIFICATION = {
  govtSchemes: 'govt_schemes',
  smsNotifications: 'sms_enabled',
  infestationPrediction: 'enable_infestation_prediction',
  farmers: 'farmer_enabled',
  fieldAgents: 'field_agent_enabled',
};
